import React, {useState, useEffect} from 'react';
import {motion} from 'framer-motion';
import {FaHandsHelping} from 'react-icons/fa';

// ===============SCROLL HEADER===============
function scrollHeader() {
  const header = document.getElementById('header');
  // When the scroll is greater than 50 viewport height, add the scroll-header class to the header tag
  if (this.scrollY >= 50) header.classList.add('scroll-header');
  else header.classList.remove('scroll-header');
}

window.addEventListener('scroll', scrollHeader);

// ===============CHANGE THEME===============
export default function Header() {
  const lightT = {
    theme: 'light-theme',
    icon: 'bx-sun',
  };
  const darkT = {
    theme: 'dark-theme',
    icon: 'bx-moon',
  };

  const selectedTheme = localStorage.getItem('theme');
  const JSONtheme = JSON.parse(selectedTheme);
  const [theme, setTheme] = useState(darkT);

  useEffect(() => {
    const bodyStyle = document.body.classList;
    const themeButton = document.getElementById('theme-button');
    localStorage.setItem('theme', JSON.stringify(theme));
    if (selectedTheme != null) {
      setTheme(JSONtheme);
      if (JSONtheme.theme === 'dark-theme') {
        bodyStyle.remove('light-theme');
        themeButton.classList.remove('bx-sun');
      }
      if (JSONtheme.theme === 'light-theme') {
        bodyStyle.add('light-theme');
        themeButton.classList.add('bx-sun');
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('theme', JSON.stringify(theme));
  }, [theme]);

  function handleTheme() {
    const bodyStyle = document.body.classList;
    const themeButton = document.getElementById('theme-button');
    if (theme.theme === 'dark-theme') {
      setTheme(lightT);
    } else if (theme.theme === 'light-theme') {
      setTheme(darkT);
    }
    bodyStyle.toggle('light-theme');
    themeButton.classList.toggle('bx-sun');
  }
  /*=============== SCROLL SECTIONS ACTIVE LINK ===============*/
  useEffect(() => {
    const sections = document.querySelectorAll('section[id]');

    function scrollActive() {
      const scrollY = window.pageYOffset;

      sections.forEach((current) => {
        const sectionHeight = current.offsetHeight,
          sectionTop = current.offsetTop - 58,
          sectionId = current.getAttribute('id');

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          document
            .querySelector('.nav__menu a[href*=' + sectionId + ']')
            .classList.add('active-link');
        } else {
          document
            .querySelector('.nav__menu a[href*=' + sectionId + ']')
            .classList.remove('active-link');
        }
      });
    }
    window.addEventListener('scroll', scrollActive);
  }, []);

  return (
    <header className='header' id='header'>
      <nav className='nav container'>
        <a href='' className='nav__logo'>
          Andrez
        </a>
        <motion.div
          initial={{y: 100}}
          animate={{y: 0}}
          transition={{type: 'spring', bounce: 0.8, duration: 2, delay: 0.6}}
          className='nav__menu'
        >
          <ul className='nav__list'>
            <li className='nav__item'>
              <a href='#home' className='nav__link active-link'>
                <i className='bx bx-home-alt'></i>
              </a>
            </li>
            <li className='nav__item'>
              <a href='#about' className='nav__link'>
                <i className='bx bx-user'></i>
              </a>
            </li>
            <li className='nav__item'>
              <a href='#skills' className='nav__link'>
                <i className='bx bx-book'></i>
              </a>
            </li>
            <li className='nav__item'>
              <a href='#services' className='nav__link'>
                <FaHandsHelping />
              </a>
            </li>
            <li className='nav__item'>
              <a href='#work' className='nav__link'>
                <i className='bx bxs-briefcase-alt-2'></i>
              </a>
            </li>
            <li className='nav__item'>
              <a href='#contact' className='nav__link'>
                <i className='bx bx-message-square-detail'></i>
              </a>
            </li>
          </ul>
        </motion.div>
        {/* <!-- Theme change button --> */}
        <i
          className='bx bx-moon change-theme'
          onClick={() => handleTheme()}
          id='theme-button'
        ></i>
      </nav>
    </header>
  );
}
